import styled from 'styled-components';
import Icon, { ContractType } from '../../../external/components/Icon/Icon';
import Text from '../../../external/components/Text/Text';

interface Props {
  token0: ContractType;
  token1: ContractType;
  symbol: string;
  title?: string;
  isZen?: boolean;
  zenSymbol?: ContractType;
}

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 2rem;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    border: solid 1px #4f5460;
  }
`;

export function SideBarHeaderLP({
  token0,
  token1,
  isZen,
  zenSymbol,
  symbol,
  title = 'Staking',
}: Props) {
  return (
    <HeaderWrapper>
      <div className='flex'>
        {!isZen ? (
          <>
            <Icon.Contract type={token0} width={45} style={{ zIndex: 1 }}></Icon.Contract>
            <Icon.Contract
              type={token1}
              width={45}
              style={{ zIndex: 1, marginLeft: '0.5rem' }}
            ></Icon.Contract>{' '}
          </>
        ) : (
          <>
            <Icon.Contract
              type={zenSymbol || 'ETH'}
              width={45}
              style={{ zIndex: 1 }}
            ></Icon.Contract>{' '}
          </>
        )}
      </div>
      <Text dark={true}>
        {symbol} - {title}
      </Text>
    </HeaderWrapper>
  );
}
